import { UserActivityLogModel } from "../shared/models/userActivityLog.model";

export class RegisterModel {
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    organizationId:string;
    location: string = "Hyderabad";
    userActivityLog? : UserActivityLogModel;
    url:string;
}
